import axios from "axios";

const base = "";

export default class {
  /**
   * Search for an org in SPIRIT with an optional limit
   * @param {int} searchTypeId The type of org search to execute
   * @param {string} search The search term (usually a postcode or school name)
   * @param {int} limit The maximum number of results to return
   */
  static orgSearch ( searchTypeId, search, limit ) {
    const appliedLimit = `&limit=${limit || 0}`;

    const query = `?query=${escape( search )}`;

    let searchType = "";
    if ( searchTypeId > 0 ) {
      searchType = `&searchTypeId=${searchTypeId}`;
    }

    return axios.get( `${base}/umbraco/Surface/OrganisationSurface/OrgLookup/${query}${appliedLimit}${searchType}` );
  }

  /**
   * Search for an address using AFD
   * @param {string} search The search term (usually a postcode)
   */
  static addressSearch ( search ) {
    const query = `?query=${escape( search )}`;

    return axios.get( `${base}/umbraco/Surface/AddressLookupSurface/AddressLookup/${query}` );
  }

  /**
   * Gets the details for an org by its ID
   * @param {GUID} id The ID of the org to look up
   */
  static getOrgById ( id ) {
    return axios.get( `${base}/umbraco/Surface/OrganisationSurface/GetFullOrg/${escape( id )}` );
  }

  /**
   * Gets the details for an address by its key
   * @param {string} postKey The AFD postkey to look up
   */
  static getAddressByKey ( postKey ) {
    return axios.get( `${base}/umbraco/Surface/AddressLookupSurface/GetFullAddress/?postKey=${escape( postKey )}` );
  }

  /**
   * Creates a promise that resolves after the given time, returning the given value.
   * Used to provide delayed fake API responses.
   * @param {int} time The number of milliseconds before the promise resolves
   * @param {any} value The value to return
   */
  static delay ( time, value ) {
    return new Promise( ( ( resolve ) => {
      setTimeout( () => {
        resolve( value );
      }, time );
    } ) );
  }
}
